import { SubFsmBuilder } from "little-fsm"
import { SeatReservationFsmContext as SeatReservationFsmContext } from "./SeatReservationFsmContext"
import { InternationalStringDTO, SeatDTO, TripCustomizationDTO, TripDTO } from "../../apiclient/ApiDtos"

export type SeatReservationFsmScheme = {
    context: SeatReservationFsmContext,
    substates: [
        'fetching_trip_details',
        'selecting_seatplan_or_auto_assignment',
        'showing_seatplan',
        'showing_auto_assignment_info_view',
        'showing_trip_fetching_error',
        'reserving_seats',
        'showing_seat_reservation_error',
    ],
    events: {
        'back': {},
        "trip_details_received": { tripDetails: TripDTO },
        "trip_details_already_reveived": {}
        "fetching_trip_detils_failed": { errorMessage: string },
        "seatplan_refetching_requested": {},

        'seatplan_mode_determined': {},
        'seats_auto_assignment_mode_determined': {},

        "seat_reservation_requested": { selectedSeats: SeatDTO[] }
        "seat_reservation_created": { tripCustomization: TripCustomizationDTO },
        "continue": {}
        "seat_reservation_failed": { errorMessage: InternationalStringDTO }
    }
}

// just simple identity function
const $I = (x) => x;

export function seatSelectionSubFsmBuilder(): SubFsmBuilder<SeatReservationFsmScheme> {
    let subBuilder = new SubFsmBuilder<SeatReservationFsmScheme>();


    subBuilder
        .entrySubstate("fetching_trip_details");

    subBuilder.substate("fetching_trip_details")
        .termination('back', $I)
        .transition('trip_details_received', 'selecting_seatplan_or_auto_assignment', (context, event) => {
            return context.withTripDetails(event.tripDetails);
        })
        .transition('trip_details_already_reveived', 'selecting_seatplan_or_auto_assignment', (context, event) => {
            return context;
        })
        .transition('fetching_trip_detils_failed', 'showing_trip_fetching_error', (context, event) => {
            return context.withTripDetailsFetchingError(event.errorMessage);
        })

    subBuilder.substate("selecting_seatplan_or_auto_assignment")
        .termination('back', $I)
        .transition('seats_auto_assignment_mode_determined', 'showing_auto_assignment_info_view', (context, event) => {
            return context;
        }).transition('seatplan_mode_determined', 'showing_seatplan', (context, event) => {
            return context;
        })


    subBuilder.substate("showing_auto_assignment_info_view")
        .termination('back', $I)
        .transition('seat_reservation_requested', 'reserving_seats', (context, event) => {
            return context;
        })
        .completion('continue', (context, event) => {
            return context;
        })
    /* .completion('seat_reservation_requested', (context, event) => {
        return context;
    }) */

    subBuilder.substate("showing_seatplan")
        .termination('back', $I)
        .completion('continue', (context, event) => {
            return context;
        })
        .transition('seat_reservation_requested', 'reserving_seats', (context, event) => {
            return context.withSelectedSeats(event.selectedSeats);
        })


    subBuilder.substate("selecting_seatplan_or_auto_assignment")
        .termination('back', $I)
        .transition('seat_reservation_requested', 'reserving_seats', (context, event) => {
            return context;
        })
        .completion('continue', (context, event) => {
            return context
                .withSelectedSeats(context.selectedSeats)
                .withTripCustomization(context.tripCustomization!!);
        })

    subBuilder.substate("reserving_seats")
        .termination('back', $I)
        .completion('seat_reservation_created', (context, event) => {
            return context.withTripCustomization(event.tripCustomization);
        })
        .transition('seat_reservation_failed', 'showing_seat_reservation_error', (context, event) => {
            return context.withError(event.errorMessage);
        })

    subBuilder.substate("showing_seat_reservation_error")
        .termination('back', $I)
        .transition('seatplan_refetching_requested', 'fetching_trip_details', $I)


    return subBuilder;
}

